// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1O-NB","left":"StickyBox_left__11eoE","right":"StickyBox_right__sEQB-"};